import { render, staticRenderFns } from "./CouponModal.vue?vue&type=template&id=5dcdba9b&"
import script from "./CouponModal.vue?vue&type=script&lang=js&"
export * from "./CouponModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports